import React from 'react';
import store from '../store';
import Breadcrumbs from '../components/Breadcrumbs';
import ClientHeader from '../components/ClientHeader';
import Profile from '../components/Profile';
import { PagePath } from '../components/GoToPage';
import _ from 'underscore';
import moment from 'moment-timezone';

import { compose, withProps, lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { connect } from 'react-redux';

// ACTIONS
import { setValidators } from '../redux/actions/ValidatorAction';
import { setValidities } from '../redux/actions/ValidityAction';
import {
    actionGetReportTypes,
    actionGenerateReport,
    setReportTypeError,
} from '../redux/actions/ReportAction';
import { startLoading, stopLoading, actionSetIsAdminPage } from '../redux/actions/PageAction';
import { actionGetTemplates } from '../redux/actions/TemplateAction';
import { translateToSemanticDropdown } from '../components/Translator';
// Misc
import { withFormUtils } from '../components/Misc/forms';
import { validateInput } from '../components/Form/FormRules';
import { REPORT_TABS, REPORT_TAB_INIT_VALUES } from '../components/Misc/report';
import {
    withTokenCheckWithRedirect,
    withForbiddenChecking,
} from '../components/Misc/authentication';
import { Tab } from 'semantic-ui-react';
import CalendarRange, { inRange } from '../components/Form/DateTimeRange';
import Button from '../components/Form/ButtonWithIcon';
import Dropdown from '../components/Form/Dropdown';
import Input from '../components/Form/InputWithLabel';
import {
    EnhancedDownloadIndicator,
    withDownloadFileHandlers,
} from '../components/DownloadIndicator';
import { getDownloadingFiles } from '../redux/selectors/FormSelector';
import { getTimezone } from '../timezone';
import { DEFAULT_FORMAT, BACKEND_DATETIME_KEYS_MAPPING } from '../components/Misc/datetime';
import { getClientDatetimeFormats } from '../datetime';
import { validateCalendarInput } from '../components/Form/Calendar/misc';
import BetaTagWrapper from '../components/BetaTag/BetaTagWrapper';
import StyledReportBetaTag from '../components/BetaTag/StyledReportBetaTag';
import SETTINGS from '../settings';

/** 0: day, 1: month */
const TABS_NAME = ['day', 'month'];
const mapStateToProps = ({ validity, template, report, validator }) => {
    const { validities } = validity;
    const { templates, id } = template;
    const { reportTypes, clients, error } = report;
    const { validators } = validator;
    return {
        validities,
        templateChoices: templates || [],
        currentTemplate: id,
        reportTypes,
        validators,
        clientChoices: clients || [],
        error,
        showBeta: SETTINGS.SHOW_BETA_TAG,
    };
};

const mapDispatchToProps = dispatch => ({
    startLoading() {
        dispatch(startLoading());
    },
    stopLoading() {
        dispatch(stopLoading());
    },
    getTemplates() {
        dispatch(actionGetTemplates());
    },
    getReportTypes() {
        dispatch(actionGetReportTypes());
    },
    async generateReport(data, reportType) {
        await dispatch(actionGenerateReport(data, reportType));
    },
});

export const reportBreadcrumbs = withProps(() => {
    return {
        breadcrumbs: [
            {
                title: 'Home',
                link: PagePath.dashboard,
            },
            {
                title: 'Reporting Management',
                link: '#',
            },
        ],
    };
});

export const PresentationalTable = ({
    breadcrumbs,
    isLoggedIn,
    isForbidden,
    Forbidden,
    handleRangeChange,
    handleReportTypeChange,
    handleApplicationIdChange,
    handleValidities,
    templateChoices,
    currentTemplate,
    reportTypes,
    validities,
    validators,
    validateForm,
    generateReport,
    handleTemplateRender,
    handleClientRender,
    handleGenerateReport,
    showBeta,
    ...props
}) => {
    if (isForbidden) return Forbidden;
    if (!isLoggedIn) return <span />;

    const reportTypesGroupByType = reformatReportTypes(reportTypes, showBeta);
    const panes = REPORT_TABS.map((tab, index) => {
        const currentTabDetails = REPORT_TAB_INIT_VALUES[tab] || {};
        const {
            menuItem,
            withinDuration = {},
            calendarType = '',
            label = {},
            maxDate = {},
        } = currentTabDetails;

        const currentTabValidities = validities[tab] || {};
        const {
            from: fromValidities,
            to: toValidities,
            reportType: reportTypeValidities,
            applicationId: applicationIdValidities,
            template: templateValidities,
            client: clientValidities,
        } = currentTabValidities || {};

        const { errorMessage: fromErrorMessage, isValid: fromIsValid } = fromValidities || {};
        const { errorMessage: toErrorMessage, isValid: toIsValid } = toValidities || {};
        const { errorMessage: reportTypeErrorMessage, isValid: reportTypeIsValid } =
            reportTypeValidities || {};
        const { errorMessage: applicationIdErrorMessage, isValid: applicationIdIsValid } =
            applicationIdValidities || {};
        const { errorMessage: templateErrorMessage, isValid: templateIsValid } =
            templateValidities || {};
        const { errorMessage: clientErrorMessage, isValid: clientIsValid } = clientValidities || {};

        const currentTabValues = props[tab] || {};
        const type =
            tab === TABS_NAME[0]
                ? BACKEND_DATETIME_KEYS_MAPPING['date']
                : BACKEND_DATETIME_KEYS_MAPPING['monthYear'];
        const format = getClientDatetimeFormats()[type];
        return {
            menuItem,
            render: () => {
                return (
                    <Tab.Pane attached={false} key={index}>
                        <div className="report report__form-section">
                            <div className="slot column__grids">
                                {tab !== 'form' && (
                                    <div className="col-xs-12 col-sm-12">
                                        <CalendarRange
                                            timezone={getTimezone()}
                                            format={format}
                                            calendarType={calendarType}
                                            errorMessage={fromErrorMessage || toErrorMessage}
                                            isValid={fromIsValid && toIsValid}
                                            label={{
                                                from: {
                                                    title: label.from,
                                                    position: 'top',
                                                },
                                                to: {
                                                    title: label.to,
                                                    position: 'top',
                                                },
                                            }}
                                            value={{
                                                from:
                                                    currentTabValues.range &&
                                                    currentTabValues.range.from,
                                                to:
                                                    currentTabValues.range &&
                                                    currentTabValues.range.to,
                                            }}
                                            maxDate={{
                                                from: maxDate.from,
                                                to: maxDate.to,
                                            }}
                                            onChange={(e, data) => {
                                                const { from, to } = data;

                                                handleRangeChange({
                                                    tab,
                                                    currentTabValues,
                                                    from,
                                                    to,
                                                    withinDuration,
                                                    calendarType,
                                                });

                                                let validity = validateForm(data, tab);

                                                validity = handleCalendarValidation({
                                                    from,
                                                    to,
                                                    withinDuration,
                                                    calendarType,
                                                    validity,
                                                });

                                                handleValidities(
                                                    validity,
                                                    currentTabValidities,
                                                    tab,
                                                );
                                            }}
                                        />
                                    </div>
                                )}
                                {tab === 'form' && (
                                    <div className="col-xs-12 col-sm-6">
                                        <Input
                                            onChange={(e, { value }) => {
                                                handleApplicationIdChange({
                                                    tab,
                                                    currentTabValues,
                                                    value,
                                                });

                                                let validity = validateInput({
                                                    validators: validators[tab]['applicationId'],
                                                    value,
                                                });
                                                validity = {
                                                    applicationId: validity,
                                                };

                                                handleValidities(
                                                    validity,
                                                    currentTabValidities,
                                                    tab,
                                                );
                                            }}
                                            value={currentTabValues.applicationId}
                                            label={{
                                                title: 'Application ID',
                                            }}
                                            isValid={applicationIdIsValid}
                                            errorMessage={applicationIdErrorMessage}
                                            placeholder="Enter Application ID"
                                        />
                                    </div>
                                )}
                                <div className="col-xs-12 col-sm-6">
                                    <Dropdown
                                        isEditable={
                                            !_.isEmpty(reportTypesGroupByType[tab]) ? true : false
                                        }
                                        label={{
                                            title: 'Report Selection',
                                            position: 'top',
                                        }}
                                        placeholder="Select report"
                                        options={reportTypesGroupByType[tab]}
                                        onChange={(e, { value }) => {
                                            handleReportTypeChange({
                                                tab,
                                                currentTabValues,
                                                value,
                                                reportTypesGroupByType,
                                            });

                                            let validity = validateInput({
                                                validators: validators[tab]['reportType'],
                                                value,
                                            });
                                            validity = {
                                                reportType: validity,
                                            };

                                            handleValidities(validity, currentTabValidities, tab);
                                        }}
                                        value={currentTabValues.reportType}
                                        errorMessage={reportTypeErrorMessage}
                                        isValid={reportTypeIsValid}
                                    />
                                </div>

                                {handleTemplateRender({
                                    templateErrorMessage,
                                    templateIsValid,
                                    tab,
                                    currentTabValues,
                                })}

                                {handleClientRender({
                                    clientErrorMessage,
                                    clientIsValid,
                                    tab,
                                    currentTabValues,
                                })}

                                <div className="col-xs-12 col-sm-12">
                                    <Button
                                        className="report__generate-button"
                                        forceGap
                                        title="Generate"
                                        onClick={() => {
                                            const {
                                                range = {},
                                                reportType = null,
                                                applicationId = null,
                                                template = null,
                                                hasTemplate = false,
                                                client = null,
                                                isInternal = false,
                                            } = currentTabValues;

                                            let { from = null, to = null } = range;
                                            // setting day
                                            if (tab === TABS_NAME[0]) {
                                                from = moment
                                                    .tz(from, getTimezone())
                                                    .startOf('day')
                                                    .toISOString();
                                                to = moment
                                                    .tz(to, getTimezone())
                                                    .startOf('day')
                                                    .add(1, 'd')
                                                    .toISOString();
                                            }
                                            // setting month
                                            else if (tab === TABS_NAME[1]) {
                                                from = moment
                                                    .tz(from, getTimezone())
                                                    .startOf('month')
                                                    .toISOString();
                                                to = moment
                                                    .tz(to, getTimezone())
                                                    .startOf('month')
                                                    .add(1, 'M')
                                                    .toISOString();
                                            }

                                            const dataToValidate = checkDataToValidate({
                                                from,
                                                to,
                                                reportType,
                                                applicationId,
                                                hasTemplate,
                                                isInternal,
                                                template,
                                                client,
                                            });

                                            let validity = validateForm(dataToValidate, tab);

                                            validity =
                                                handleCalendarValidation({
                                                    from,
                                                    to,
                                                    withinDuration,
                                                    calendarType,
                                                    validity,
                                                }) || {};

                                            handleValidities(validity, currentTabValidities, tab);

                                            const isError = Object.values(validity).some(input => {
                                                return input.isValid === false;
                                            });

                                            if (!isError) {
                                                const data = {
                                                    from,
                                                    to,
                                                    reportType,
                                                    applicationId,
                                                    template,
                                                    client,
                                                };
                                                handleGenerateReport(data);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </Tab.Pane>
                );
            },
        };
    });

    return (
        <div className="container content template">
            <div className="profile__client">
                <ClientHeader />
                <Profile />
            </div>
            <Breadcrumbs option={breadcrumbs} />
            <div className="page__content content--big content-title">Reporting Management</div>

            <Tab
                className="content__tab"
                menu={{
                    secondary: true,
                    pointing: true,
                }}
                panes={panes}
                renderActiveOnly={true}
            />
            <EnhancedDownloadIndicator />
        </div>
    );
};

PresentationalTable.defaultProps = {
    validities: {},
    validateForm: _.noop,
    handleTemplateRender: _.noop,
    handleClientRender: _.noop,
    handleValidities: _.noop,
    handleGenerateReport: _.noop,
};

const initialState = {
    day: {
        range: {
            from: '',
            to: '',
            isValid: true,
            errorMessage: '',
        },
        reportType: '',
        template: '',
        hasTemplate: false,
        isInternal: false,
    },
    month: {
        range: {
            from: '',
            to: '',
            isValid: true,
            errorMessage: '',
        },
        reportType: '',
        template: '',
        hasTemplate: false,
        isInternal: false,
    },
    form: {
        range: {
            from: '',
            to: '',
            isValid: true,
            errorMessage: '',
        },
        reportType: '',
        applicationId: '',
        template: '',
        hasTemplate: false,
        isInternal: false,
    },
};

const onRangeChange = state => range => {
    return {
        ...state,
        ...range,
    };
};

const onReportTypeChange = state => reportType => {
    return {
        ...state,
        ...reportType,
    };
};

const onApplicationIdChange = state => applicationId => {
    return {
        ...state,
        ...applicationId,
    };
};

const onTemplateChange = state => template => {
    return {
        ...state,
        ...template,
    };
};

export const REPORT_VALIDATORS = {
    day: {
        from: ['isRequired'],
        to: ['isRequired'],
        reportType: ['isRequired'],
        template: ['isRequired'],
        client: ['isRequired'],
    },
    month: {
        from: ['isRequired'],
        to: ['isRequired'],
        reportType: ['isRequired'],
        template: ['isRequired'],
        client: ['isRequired'],
    },
    form: {
        applicationId: ['isRequired'],
        reportType: ['isRequired'],
        template: ['isRequired'],
    },
};

export const onClientChange = state => client => {
    return {
        ...state,
        ...client,
    };
};

export const handleCalendarValidation = ({ from, to, withinDuration, calendarType, validity }) => {
    let isValid = true;
    let errorMessage = '';
    const format = DEFAULT_FORMAT[calendarType];

    const isWithinRange = checkInRangeWithinDuration({
        value: {
            from,
            to,
        },
        withinDuration,
    });

    if (!isWithinRange.isValid) {
        isValid = isWithinRange.isValid;
        errorMessage = isWithinRange.errorMessage;
    }

    const isFromMoreThanTo = inRange({
        value: {
            from,
            to,
        },
        type: calendarType,
    });

    if (!isFromMoreThanTo) {
        isValid = isFromMoreThanTo;
        errorMessage = 'From more than To';
    }

    const fromValidity = validateCalendarInput({
        value: from,
        format,
        type: calendarType,
    });
    const toValidity = validateCalendarInput({
        value: to,
        format,
        type: calendarType,
    });

    if (!fromValidity.isValid) {
        validity = {
            ...validity,
            from: {
                isValid: fromValidity.isValid,
                errorMessage: 'Range is invalid',
            },
        };
    }

    if (!toValidity.isValid) {
        validity = {
            ...validity,
            to: {
                isValid: toValidity.isValid,
                errorMessage: 'Range is invalid',
            },
        };
    }

    if (!isValid) {
        validity = {
            ...validity,
            from: {
                isValid,
                errorMessage,
            },
            to: {
                isValid,
                errorMessage,
            },
        };
    }

    return validity;
};

export function checkInRangeWithinDuration({ value = {}, withinDuration = {} }) {
    // durationType can be 'days', 'months', 'years' etc
    const { durationLength, durationType } = withinDuration;

    if (_.isEmpty(value)) return true;

    const from = moment(value.from);
    const to = moment(value.to);

    const rangeLength = moment(to).diff(moment(from), durationType, true);

    let errorMessage = '';
    if (rangeLength > durationLength) {
        errorMessage = `Selection should be within ${durationLength} ${durationType}`;
        return { isValid: false, errorMessage };
    }

    return { isValid: true, errorMessage };
}

export function reformatTemplates(templateChoices) {
    const modifiedTemplates = translateToSemanticDropdown({
        options: templateChoices,
        translateTo: {
            id: ['value'],
            name: 'title',
        },
    });
    return modifiedTemplates;
}

export function reformatClients(clientChoices) {
    const modifiedClients = translateToSemanticDropdown({
        options: clientChoices,
        translateTo: {
            slug: ['value'],
            name: 'title',
        },
    });
    return modifiedClients;
}

function renderReportTitle(title, isBeta) {
    return isBeta ? (
        <BetaTagWrapper>
            {title}
            <StyledReportBetaTag />
        </BetaTagWrapper>
    ) : (
        title
    );
}

export function reformatReportTypes(reportTypes = {}, showBeta) {
    const modifiedReportTypes = Object.entries(reportTypes).map(([_id, report]) => ({
        value: report.id,
        name: report.id,
        title: renderReportTitle(report.name, showBeta && report.beta),
        type: report.type,
        hasTemplate: report.has_template,
        isInternal: report.is_internal,
    }));
    const reportTypesGroupByType = _.groupBy(modifiedReportTypes, 'type');
    return reportTypesGroupByType;
}

export const checkDataToValidate = ({
    from,
    to,
    reportType,
    applicationId,
    hasTemplate,
    isInternal,
    template,
    client,
}) => {
    let dataToValidate = {
        from,
        to,
        reportType,
        applicationId,
    };

    if (hasTemplate) {
        dataToValidate = {
            ...dataToValidate,
            template,
        };
    }

    if (isInternal) {
        dataToValidate = {
            ...dataToValidate,
            client,
        };
    }

    return dataToValidate;
};

export const withEventHandlers = withHandlers({
    validateForm:
        ({ validators }) =>
        (dataToValidate, tab) => {
            const validities = _.mapObject(dataToValidate, (value, key) => {
                const validateEach = validateInput({
                    validators: validators[tab][key],
                    value,
                });
                return validateEach;
            });
            return validities;
        },
    handleRangeChange:
        ({ onRangeChange }) =>
        ({ tab, currentTabValues, from, to }) => {
            onRangeChange({
                [tab]: {
                    ...currentTabValues,
                    range: {
                        from,
                        to,
                    },
                },
            });
        },
    handleApplicationIdChange:
        ({ onApplicationIdChange }) =>
        ({ tab, currentTabValues, value }) => {
            onApplicationIdChange({
                [tab]: {
                    ...currentTabValues,
                    applicationId: value,
                },
            });
        },
    handleReportTypeChange:
        ({ onReportTypeChange }) =>
        ({ tab, currentTabValues, value, reportTypesGroupByType }) => {
            const reportTypes = reportTypesGroupByType[tab] || [];
            const { hasTemplate = false, isInternal = false } =
                reportTypes.filter(i => i.value === value)[0] || {};

            onReportTypeChange({
                [tab]: {
                    ...currentTabValues,
                    reportType: value,
                    template: null,
                    hasTemplate,
                    isInternal,
                },
            });
        },
    handleTemplateChange:
        ({ onTemplateChange }) =>
        ({ tab, currentTabValues, value }) => {
            onTemplateChange({
                [tab]: {
                    ...currentTabValues,
                    template: value,
                },
            });
        },
    handleClientChange:
        ({ onClientChange }) =>
        ({ tab, currentTabValues, value }) => {
            onClientChange({
                [tab]: {
                    ...currentTabValues,
                    client: value,
                },
            });
        },
    handleValidities:
        ({ validities }) =>
        (validity, currentTabValidities, tab) => {
            store.dispatch(
                setValidities({
                    ...validities,
                    [tab]: {
                        ...currentTabValidities,
                        ...validity,
                    },
                }),
            );
        },
    handleGenerateReport:
        ({ reportTypes, pushDownloadingFiles, popDownloadingFileById, generateReport }) =>
        async data => {
            const files = getDownloadingFiles(store.getState());
            // Reset counter when no files are pending
            if (!files.length) {
                reportTypes.map(obj => (obj['counter'] = 0));
            }

            const currentReport = reportTypes.find(i => i.id === data.reportType);
            const id = `${currentReport.name} ${(currentReport.counter += 1)}`;
            // Set downloading files to indicator
            pushDownloadingFiles({ id, name: id });
            // Do report generation
            await generateReport(data, data.reportType);
            // Remove files from indicator
            popDownloadingFileById({ id });
        },
});

export const reportHOC = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withFormUtils,
    withStateHandlers(initialState, {
        onRangeChange,
        onReportTypeChange,
        onApplicationIdChange,
        onTemplateChange,
        onClientChange,
    }),
    withDownloadFileHandlers,
    withEventHandlers,
    withHandlers({
        handleTemplateRender:
            ({
                currentTabValidities,
                handleValidities,
                validators,
                templateChoices,
                handleTemplateChange,
            }) =>
            ({ templateErrorMessage, templateIsValid, tab, currentTabValues }) => {
                const modifiedTemplates = reformatTemplates(templateChoices);

                if (!currentTabValues.hasTemplate) return <span />;

                return (
                    <div className="col-xs-12 col-sm-6">
                        <Dropdown
                            isEditable={true}
                            label={{
                                title: 'Template Selection',
                                position: 'top',
                            }}
                            placeholder="Select template"
                            options={modifiedTemplates}
                            onChange={(e, { value }) => {
                                handleTemplateChange({
                                    tab,
                                    currentTabValues,
                                    value,
                                });

                                let validity = validateInput({
                                    validators: validators[tab]['template'],
                                    value,
                                });
                                validity = {
                                    template: validity,
                                };
                                handleValidities(validity, currentTabValidities, tab);
                            }}
                            value={currentTabValues.template}
                            errorMessage={templateErrorMessage}
                            isValid={templateIsValid}
                        />
                    </div>
                );
            },
        handleClientRender:
            ({
                currentTabValidities,
                handleValidities,
                validators,
                clientChoices,
                handleClientChange,
            }) =>
            ({ clientErrorMessage, clientIsValid, tab, currentTabValues }) => {
                const modifiedClients = reformatClients(clientChoices);
                if (!currentTabValues.isInternal) return <span />;

                return (
                    <div className="col-xs-12 col-sm-6">
                        <Dropdown
                            isEditable={true}
                            label={{
                                title: 'Client Selection',
                                position: 'top',
                            }}
                            placeholder="Select client"
                            options={modifiedClients}
                            onChange={(e, { value }) => {
                                handleClientChange({
                                    tab,
                                    currentTabValues,
                                    value,
                                });

                                let validity = validateInput({
                                    validators: validators[tab]['client'],
                                    value,
                                });
                                validity = {
                                    client: validity,
                                };
                                handleValidities(validity, currentTabValidities, tab);
                            }}
                            value={currentTabValues.client}
                            errorMessage={clientErrorMessage}
                            isValid={clientIsValid}
                        />
                    </div>
                );
            },
    }),
    lifecycle({
        componentDidMount() {
            store.dispatch(actionSetIsAdminPage());
            store.dispatch(setValidators(REPORT_VALIDATORS));
            store.dispatch(
                setValidities({
                    day: {
                        from: {
                            isValid: true,
                            errorMessage: '',
                        },
                        to: {
                            isValid: true,
                            errorMessage: '',
                        },
                        reportType: {
                            isValid: true,
                            errorMessage: '',
                        },
                        template: {
                            isValid: true,
                            errorMessage: '',
                        },
                        client: {
                            isValid: true,
                            errorMessage: '',
                        },
                    },
                    month: {
                        from: {
                            isValid: true,
                            errorMessage: '',
                        },
                        to: {
                            isValid: true,
                            errorMessage: '',
                        },
                        reportType: {
                            isValid: true,
                            errorMessage: '',
                        },
                        template: {
                            isValid: true,
                            errorMessage: '',
                        },
                        client: {
                            isValid: true,
                            errorMessage: '',
                        },
                    },
                    form: {
                        applicationId: {
                            isValid: true,
                            errorMessage: '',
                        },
                        reportType: {
                            isValid: true,
                            errorMessage: '',
                        },
                        template: {
                            isValid: true,
                            errorMessage: '',
                        },
                    },
                }),
            );
            this.props.getTemplates();
            this.props.getReportTypes();
        },
        componentDidUpdate(prevProps) {
            const { fetching, startLoading, stopLoading, error, showErrorForm, hideForm } =
                this.props;

            const willLoad = !_.any(_.values(prevProps.fetching)) && _.any(_.values(fetching));
            const stopLoad = _.any(_.values(prevProps.fetching)) && !_.any(_.values(fetching));
            if (willLoad) {
                startLoading();
            } else if (stopLoad) {
                stopLoading();
            }

            if (!prevProps.error && error) {
                showErrorForm({
                    message: error,
                    onOk() {
                        store.dispatch(setReportTypeError(null));
                        hideForm();
                    },
                });
            }
        },
    }),
);

export const withForbiddenFeature = withProps(({ features }) => {
    let isForbidden = false;
    if (features) {
        const featureTypes = features.map(f => f.type);
        isForbidden = !(
            _.includes(featureTypes, 'business_reporting_management') ||
            _.includes(featureTypes, 'it_reporting_management') ||
            _.includes(featureTypes, 'reporting_management') ||
            _.includes(featureTypes, 'jewel_internal_report')
        );
    }
    return {
        isForbidden,
    };
});

const reportComponent = compose(
    reportBreadcrumbs,
    reportHOC,
    connect(({ user }) => {
        return {
            features: user.features,
        };
    }),
    withForbiddenChecking,
    withForbiddenFeature,
    withTokenCheckWithRedirect,
)(PresentationalTable);

export default reportComponent;
